import type { CapabilityObj } from 'homey-api';
import { Option, Select } from './Select';

interface CapabilitySelectProps {
  selectedCapabilityId: string | null;
  componentCapabilities: string[];
  capabilitiesObj?: Record<string, CapabilityObj>;
  onSelectionChange: (capabilityId: string | null) => void;
}

export function CapabilitySelect({
  selectedCapabilityId,
  componentCapabilities,
  capabilitiesObj,
  onSelectionChange,
}: CapabilitySelectProps) {
  return (
    // @ts-expect-error
    <Select
      aria-label="Capability Select"
      selectedKey={selectedCapabilityId ?? null}
      // @ts-expect-error
      onSelectionChange={(key) => {
        onSelectionChange(key ?? null);
      }}
    >
      {componentCapabilities.map((capabilityId) => {
        return (
          <Option key={capabilityId}>
            {getOptionLabel({
              option: capabilityId,
              capabilitiesObj,
            })}
          </Option>
        );
      })}
    </Select>
  );
}

function getOptionLabel({
  option,
  capabilitiesObj,
}: {
  option: string;
  capabilitiesObj?: Record<string, CapabilityObj>;
}) {
  const capability = capabilitiesObj?.[option];
  return capability != null ? capability.title : '';
}
